<div fxLayout="row" class="toggle" fxFlex>
    <!-- <div class="option" *ngFor="let option of options" spyOn="{{option.title}}" activeClass="active" [ngx-scroll-to]="'#'+option.title" [ngx-scroll-to-offset]="-160" (click)="currentOption=option.title" [ngClass]="currentOption === option.title ? 'active' : ''"> -->
    <div class="option" *ngFor="let option of options" (click)="onClickScroll(option.id)" fxFlex>
      <div class="content">{{option.title}}</div>
      <div class="bisel"></div>
    </div>
  </div>